export default [
  {value: '1', label: '未激活'},
  {value: '2', label: '禁用'},
  {value: '3', label: '上线'},
  {value: '4', label: '离线'}
]
